"use strict";
exports.__esModule = true;
exports.RateService = void 0;
var operators_1 = require("rxjs/operators");
var store_1 = require("./store");
var rxjs_1 = require("rxjs");
var rate_helper_service_1 = require("./rate-helper.service");
var getRates = function (sessionId) {
    store_1.RateStore.setLoading(true);
    return rate_helper_service_1.RateHelperService.fetchRate(sessionId).pipe(operators_1.map(function (rates) {
        store_1.RateStore.setLoading(false);
        store_1.RateStore.set(rates);
        return rates;
    }), operators_1.catchError(function (err) {
        store_1.RateStore.setLoading(false);
        console.log(err);
        return rxjs_1.of([]);
    }));
};
var getSingleRate = function (sessionId, rateId) {
    return rate_helper_service_1.RateHelperService.getSingleRate(sessionId, rateId).pipe(operators_1.map(function (rate) { return rate; }), operators_1.catchError(function (err) {
        console.log(err);
        return rxjs_1.of({});
    }));
};
var resetCacheFetchRate = function () { return rate_helper_service_1.RateHelperService.resetCacheFetchRate(); };
exports.RateService = { getRates: getRates, resetCacheFetchRate: resetCacheFetchRate, getSingleRate: getSingleRate };
//# sourceMappingURL=rate.service.js.map